"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctionReportResponseSchema = exports.correctionReportSummarySchema = exports.correctionReportRowSchema = exports.correctionReportFamilyEnum = exports.correctionReportDetailLineSchema = void 0;
const zod_1 = require("zod");
const financial_payment_correction_request_1 = require("../request/financial-payment-correction.request");
const financial_correction_stage_response_1 = require("./financial-correction-stage.response");
const financial_correction_register_response_1 = require("./financial-correction-register.response");
/** One before/after line of a request: what the receipt carries now and what was asked for. */
exports.correctionReportDetailLineSchema = zod_1.z.object({
    label: zod_1.z.string(),
    from: zod_1.z.string().nullable(),
    to: zod_1.z.string().nullable(),
});
/** The kind of document the request is about, in the desk's words. */
exports.correctionReportFamilyEnum = zod_1.z.enum(['OP_RECEIPT', 'WALK_IN_RECEIPT', 'IP_ADVANCE']);
/** One correction request with everything the audit asks about it. */
exports.correctionReportRowSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    /** A short, quotable handle for the request (the first eight characters of its id, upper-case). */
    reference: zod_1.z.string(),
    parameter: financial_correction_register_response_1.correctionRegisterParameterEnum,
    family: exports.correctionReportFamilyEnum,
    receiptNumber: zod_1.z.string().nullable(),
    opNumber: zod_1.z.string().nullable(),
    patientName: zod_1.z.string().nullable(),
    amountPaise: zod_1.z.number().int(),
    /** The headline change in one readable string each; `details` has every line. */
    fromValue: zod_1.z.string().nullable(),
    toValue: zod_1.z.string().nullable(),
    details: zod_1.z.array(exports.correctionReportDetailLineSchema),
    reason: zod_1.z.string(),
    requestedById: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    requestedAt: zod_1.z.string(),
    verifiedByName: zod_1.z.string().nullable(),
    verifiedAt: zod_1.z.string().nullable(),
    verificationNote: zod_1.z.string().nullable(),
    /** Who approved it — or rejected it, whichever `status` says. */
    decidedByName: zod_1.z.string().nullable(),
    decidedAt: zod_1.z.string().nullable(),
    decisionReason: zod_1.z.string().nullable(),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum,
    stage: financial_correction_stage_response_1.correctionStageEnum,
    /** Hours from entry to the final decision, one decimal. Null while the request is still open. */
    turnaroundHours: zod_1.z.number().nullable(),
    /** Hours the request has been open, one decimal. Null once it is decided. */
    waitingHours: zod_1.z.number().nullable(),
    /** What approval changed, in plain sentences (receipt corrections). Empty until approved. */
    appliedSummary: zod_1.z.array(zod_1.z.string()),
    /** The reclassifying journal entry an approved payment-method correction posted. */
    journalEntryNumber: zod_1.z.string().nullable(),
});
exports.correctionReportSummarySchema = zod_1.z.object({
    total: zod_1.z.number().int(),
    awaitingVerification: zod_1.z.number().int(),
    awaitingApproval: zod_1.z.number().int(),
    approved: zod_1.z.number().int(),
    rejected: zod_1.z.number().int(),
    /** Value of the receipts whose correction is still waiting for a decision. Server-summed. */
    openAmountPaise: zod_1.z.number().int(),
    /** Value of the receipts whose correction was approved. Server-summed. */
    approvedAmountPaise: zod_1.z.number().int(),
    byParameter: zod_1.z.array(zod_1.z.object({ parameter: financial_correction_register_response_1.correctionRegisterParameterEnum, count: zod_1.z.number().int() })),
    /** Mean hours from entry to decision over the decided requests in the set. Null when none is decided. */
    avgTurnaroundHours: zod_1.z.number().nullable(),
    /** The longest an open request in the set has been waiting. Null when none is open. */
    oldestWaitingHours: zod_1.z.number().nullable(),
});
exports.correctionReportResponseSchema = zod_1.z.object({
    summary: exports.correctionReportSummarySchema,
    rows: zod_1.z.array(exports.correctionReportRowSchema),
    /** More rows matched than were returned — narrow the dates (the summary above still covers every match). */
    truncated: zod_1.z.boolean(),
    /** Everyone who entered a request in the date range, for the "Requested by" filter. */
    requesters: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() })),
    generatedAt: zod_1.z.string(),
});
//# sourceMappingURL=financial-correction-report.response.js.map